module.exports = __webpack_public_path__ + "static/media/logo.629d8fe3.jpeg";